import * as React from "react";
import { observer } from "mobx-react-lite";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { ProviderHetznerDedicatedServerNodePool } from "./dedicatedNodePool";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";

type RouteParams = "index";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderHetznerDedicatedServerNodePoolContainerRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const { pathname } = useLocation();

  const { index: indexStr } = useParams<RouteParams>();
  const index = Number(indexStr);

  const h = mk8sDraft.provider_hetzner;
  const np = h.dedicatedServerNodePools.find((np) => np.index === index);

  if (!np) {
    return <Navigate to={`${pathname.split("/-dedicated-server-node-pools")[0]}/-dedicated-server-node-pools`} />;
  }

  return (
    <ProviderHetznerDedicatedServerNodePool
      mk8s={mk8s}
      mk8sDraft={mk8sDraft}
      hetzner={h}
      nodePool={np}
      index={index}
    />
  );
};

export const ProviderHetznerDedicatedServerNodePoolContainer = observer(ProviderHetznerDedicatedServerNodePoolContainerRaw);
